module.exports = __webpack_public_path__ + "static/media/copyClipboard.aedf5025.svg";